import * as XLSX from 'xlsx'
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist'

GlobalWorkerOptions.workerSrc = ``

export const handleFile = async (
  file: File,
  setData?: (d: any) => void,
  rowFormat: 'object' | 'array' = 'array'
) => {
  const reader = new FileReader()
  reader.onload = (e) => {
    /* Parse data */
    const ab = e.target?.result
    const wb = XLSX.read(ab, { type: 'array' })
    /* Get first worksheet */
    const wsname = wb.SheetNames[0]
    const ws = wb.Sheets[wsname]
    /* Convert array of arrays */
    const data = XLSX.utils.sheet_to_json(ws, {
      ...(rowFormat === 'array' ? { header: 1 } : {}),
      ...(rowFormat === 'object' ? { defval: '' } : {}),
    })
    // const cols = makeCols(ws['!ref']);
    /* update state*/
    if (setData) setData(data)
  }
  reader.readAsArrayBuffer(file)
  return reader.DONE
}

export const exportFile = (
  data: any[],
  filename = new Date().toLocaleDateString()
) => {
  /* convert state to workbook */
  const ws = XLSX.utils.aoa_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
  /* generate XLSX file and send to client */
  XLSX.writeFile(wb, filename + '.xlsx')
}

/* generate an array of column objects */
export const makeCols = (refstr: string) => {
  let o = [],
    C = XLSX.utils.decode_range(refstr).e.c + 1
  for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i }
  return o
}

export const copyToClipboard = async (text: string, cb?: () => void) => {
  await navigator.clipboard.writeText(text)
  cb?.()
}

export async function convertPdfPageToPng(pdfUrl: string) {
  const pdf = await getDocument(pdfUrl).promise
  const page = await pdf.getPage(1)

  const viewport = page.getViewport({ scale: 2 }) // 2x scale for sharpness
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  canvas.width = viewport.width
  canvas.height = viewport.height

  await page.render({
    canvasContext: context!,
    viewport: viewport,
    canvas,
  } as any).promise

  return canvas.toDataURL('image/png')
}
